import axios from 'axios';

const AxiosCreate = ({ baseUrl }) => {
  if (baseUrl != null) {
    return axios.create({
      baseURL: baseUrl,
      timeout: Number.parseInt(process.env.REACT_APP_API_REQUEST_TIMEOUT),
    });
  }
  return axios.create({
    timeout: Number.parseInt(process.env.REACT_APP_API_REQUEST_TIMEOUT),
  });
};

const AxiosInstanceBasic = ({ baseUrl }) => {
  const _instance = AxiosCreate({ baseUrl: baseUrl });
  _instance.interceptors.request.use(
      (config) => ({
        ...config,
        headers: {
          ...config.headers,
        },
      }),
      (error) => Promise.reject(error)
  );
  return _instance;
};

export const AxiosInstanceWithRefresh = ({
                                           baseUrl,
                                         }) => {
  const _instance = AxiosCreate({ baseUrl: baseUrl });
  _instance.interceptors.request.use(
      async (config) => {
        const controller = new AbortController();

        return {
          ...config,
          signal: controller.signal,
          headers: {
            ...config.headers,
          },
        };
      },
      (error) => Promise.reject(error)
  );
  return _instance;
};
